import React from "react";
import { PropTypes } from "prop-types";
import { BtnSimple } from "../../_atoms/_btn-simple/BtnSimple.js";
export const Hero = ({
  title,
  subtitle,
  button,
  link,
  alt,
  aria,
  type,
  img,
  css,
  onClick,
  buttonCSS,
}) => {
  return (
    <div className={`hero ${css}`}>
      <img className="hero__bg" src={img} alt={alt} />
      <div className="container-grid">
        <div className="hero__info" data-col-md="6">
          <h1 className="span h2">{title}</h1>
          <h2 className="h4">{subtitle}</h2>

          <BtnSimple
            aria={aria}
            type={type}
            href={link}
            css={`btn-simple ${buttonCSS}`}
            children={button}
            onClick={onClick}
            target= "_blank"
          />
        </div>
      </div>
    </div>
  );
};

Hero.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};
